import React, { useState } from 'react';
import { Alert, Col, ControlLabel, Row } from 'react-bootstrap';
import { RadioSelectNotRedux } from '../../../../common/components/RadioSelect/RadioSelect';
import { Button } from '../../../../common/components';
import { MedicalQuestionContainer } from '../MedicalQuestionContainer/MedicalQuestionContainer';

export const BooleanQuestion = ({
  conditionNumber,
  questionNumber,
  optionsList,
  onSetAnswer,
  text,
  info,
  warning,
  isEditingAnswer,
}) => {
  const options = optionsList.map((opt) => ({
    value: opt.attributes.number,
    label: opt.attributes.text,
  }));

  const currentAnswer = optionsList.find((opt) => opt.attributes.is_selected);
  const currentAnswerNumber = currentAnswer?.attributes?.number;

  const cancelEditing = () => {
    onSetAnswer(conditionNumber, questionNumber, {
      id: currentAnswerNumber,
    });
  };

  const setAnswer = (answer) => {
    onSetAnswer(
      conditionNumber,
      questionNumber,
      {
        id: answer,
      },
      isEditingAnswer,
    );
  };

  const value = warning ? undefined : currentAnswerNumber;

  return (
    <MedicalQuestionContainer
      isActive
      button={
        isEditingAnswer &&
        !warning && (
          <Button
            bsStyle="primary"
            size={'xs'}
            label={warning ? 'Update' : 'Cancel'}
            handleClick={cancelEditing}
          />
        )
      }
    >
      <BooleanQuestionSelect
        key={value || 'bool-select-question'}
        onSetAnswer={setAnswer}
        text={text}
        info={info}
        warning={warning}
        options={options}
        value={value}
      />
    </MedicalQuestionContainer>
  );
};

const BooleanQuestionSelect = ({ text, info, warning, onSetAnswer, options, value }) => {
  const [answer, setBooleanAnswer] = useState(value || '');

  const handleRadioChange = (e) => {
    const answer = e;
    setBooleanAnswer(answer);
    onSetAnswer(answer);
  };

  return (
    <div>
      <Row>
        <Col sm={12}>
          <ControlLabel>
            <span style={{ fontWeight: 'bold' }}>{text}</span>
          </ControlLabel>
        </Col>
      </Row>
      {warning && <Alert bsStyle={'danger'}>{warning}</Alert>}

      {!!info && (
        <Row>
          <Col sm={12}>
            <p className="text-info text-justify" style={{ fontSize: '14px' }}>
              {info}
              <br />
            </p>
          </Col>
        </Row>
      )}
      <Row>
        <Col sm={12}>
          <div className="radio-container-boolean-question">
            <RadioSelectNotRedux
              inline={true}
              options={options}
              onChange={handleRadioChange}
              value={answer}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};
